import { SubscriberPackageKey } from 'library/ts/model/user/SubscriberPackageKey';
import { AbstractFWCustomParams } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFWCustomParams';
import { UserModel } from 'tag/ts/tag/model/vo/UserModel';
export class FWPauseAdCustomParams extends AbstractFWCustomParams {
    adParams;
    constructor(argument) {
        super({
            name: 'FWPauseAdCustomParams',
            ...argument
        });
        this.adParams = this.#createParams();
    }
    #createParams() {
        const paramsVO = this?.tag?.params;
        const tfcd = !this.utils.Type.isEmpty(this.siteSessionData?.tfcd) ? this.siteSessionData?.tfcd?.toString() : undefined;
        const userModel = new UserModel({ tag: this?.tag, paramsUser: paramsVO?.USER });
        const currentValidStatus = userModel.getCurrentValidStatus();
        const params = {
            cpPre: !!this.isLive() ? undefined : this.siteSessionData?.cpPre,
            cpSession: !!this.isLive() ? undefined : this.siteSessionData?.cpSession,
            ge: this.siteSessionData?.ge,
            gr: this.siteSessionData?.gr,
            sub: this.siteSessionData?.sub,
            subses: this.siteSessionData?.subses,
            sz: this.fwConstants.size,
            tfcd: tfcd,
            tve: currentValidStatus?.key === SubscriberPackageKey.TVE ? currentValidStatus?.value : undefined,
            tsb: currentValidStatus?.key === SubscriberPackageKey.TSB ? currentValidStatus?.value : undefined,
            user: paramsVO?.CONTEXT?.metadata?.userProfileCategory,
            vguid: this.siteSessionData?.vguid,
            host: this.siteSessionData?.host,
            partner: this.siteSessionData?.partner,
            ptype: this.siteSessionData?.ptype,
            session: this.siteSessionData?.session,
            sb: currentValidStatus?.key === SubscriberPackageKey.SB ? currentValidStatus?.value : undefined,
            section: this.siteSessionData?.section,
            bundle: userModel.bundleStatuses,
            packageSource: paramsVO?.USER?.packageSource,
            _fw_h_x_country: this.siteSessionData?.region,
            _fw_content_language: this.siteSessionData?.lang,
            device_region_language: this.siteSessionData?.device_region_language,
            language_selection: this.createLanguageSelection(),
            endcard: this.siteSessionData?.endcard,
            gpp: this.siteSessionData?.gpp,
            gpp_sid: this.siteSessionData?.gpp_sid
        };
        this.logger?.log('createParams:', params);
        return params;
    }
    get adParameters() {
        return this.adParams;
    }
}
